<template>
    <div>
        <div class="pa-16">
            <p>
            <div class="text-h4 font-weight-light">Cookie Information</div>
            </p>
            <br>
            <div class="body-content">
                <p>
                    Cookies are small text files that are either stored in memory while you are connected with a website
                    and then deleted immediately afterward <strong>(“Session Cookies”)</strong>, or placed on your
                    device by websites
                    that you visit to store some useful information that can be used on future visits to help “remember”
                    specific choices or data entries you have made previously <strong>(“Persistent Cookies”)</strong>.
                    Cookies are widely
                    used to help websites function as efficiently as possible, as well as to provide information to the
                    owners of the website in some cases. These cookies do not read other data from an individual’s
                    computer or share information with cookies from other sites.
                </p>
                <br>
                <p>
                    We record and store details of the pages visited so that we can generate usage statistics and audit
                    permission levels from time to time. We do not sell or share any information gathered to other
                    companies.
                </p>
                <br>
                <p>
                    You can configure your web browser to accept all cookies, reject all cookies, or notify you when a
                    cookie is set. Each web browser is different, so check the "help" menu of your web browser to learn
                    how to change your cookie preferences. If an individual rejects all non-essential cookies, an
                    individual may not be able to use some or all of the features of this site. This site is not able to
                    respond to web browser DNT (do not track) requests.
                </p>
                <br>
                <p>
                    The table below provides more detail on the specific cookies used on this Website:
                </p>
                <br>
                <p>
                    <v-table>
                        <thead>
                            <tr style="background-color: #0d2155; color:white;">
                                <th class="text-left">
                                    Cookie Types
                                </th>
                                <th class="text-left">
                                    Name(s) of cookies used by this site
                                </th>
                                <th class="text-left">
                                    Purpose
                                </th>
                                <th class="text-left">
                                    Personal Data stored within the cookie
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="background-color: #e5f6ff;">
                                <td>
                                    ESSENTIAL
                                    .vimeo.com
                                </td>
                                <td>
                                    __cf_bm -
                                    vuid
                                </td>
                                <td>
                                    Visit https://vimeo.com/cookie_policy for details
                                </td>
                                <td>
                                    None
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </p>
                <br>
                <p>
                <div class="font-italic">CONTACTING THE WEB SITE ADMINISTRATOR</div>
                </p>
                <br>
                <p>
                    If you have any questions, enquiries or complaints regarding this Cookie Policy or the use of this
                    Information, please use the “Contact Us” link on the site.
                </p>
                <br>
                <p>
                    <!-- <a href="mailto:data.protection.manager@eu.biworldwide.com">data.protection.manager@eu.biworldwide.com</a> -->
                </p>
                <br>
                <br>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()

</script>